import { render, staticRenderFns } from "./SpinnerButtonComponent.vue?vue&type=template&id=5482614c&scoped=true&"
import script from "./SpinnerButtonComponent.vue?vue&type=script&lang=js&"
export * from "./SpinnerButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerButtonComponent.vue?vue&type=style&index=0&id=5482614c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482614c",
  null
  
)

export default component.exports